var CONFUSEDCMS = CONFUSEDCMS || {},
    CONFUSEDCARFINANCECALCULATORAPP = CONFUSEDCARFINANCECALCULATORAPP || {};

(function () {
    'use strict';

    CONFUSEDCARFINANCECALCULATORAPP.submitCalculation = function (
        providerLow, providerModerate, providerHigh, howMuch, howLong) {

        CONFUSEDCARFINANCECALCULATORAPP.submitPageEvent({
            EventType: 'carfinancecalculator:calculation:clicked',
            EventInfo: {
                'ProviderLowRate': providerLow.CalculationTierPercentage(),
                'ProviderLowMonthlyRepayment': providerLow.CalculationMonthlyRepayment(),
                'ProviderLowTotalRepayment': providerLow.CalculationTotalRepayment(),
                'ProviderModerateRate': providerModerate.CalculationTierPercentage(),
                'ProviderModerateMonthlyRepayment': providerModerate.CalculationMonthlyRepayment(),
                'ProviderModerateTotalRepayment': providerModerate.CalculationTotalRepayment(),
                'ProviderHighRate': providerHigh.CalculationTierPercentage(),
                'ProviderHighMonthlyRepayment': providerHigh.CalculationMonthlyRepayment(),
                'ProviderHighTotalRepayment': providerHigh.CalculationTotalRepayment(),
                'Amount': howMuch,
                'Months': howLong
            }
        });
    };

    CONFUSEDCARFINANCECALCULATORAPP.submitClickthrough = function (name, link) {

        CONFUSEDCARFINANCECALCULATORAPP.submitPageEvent({
            EventType: 'carfinancecalculator:' + name + ':clicked',
            EventInfo: {
                'Link': link
            }
        });
    };

    CONFUSEDCARFINANCECALCULATORAPP.submitProvider = function (providerType, isDropdown) {

        CONFUSEDCARFINANCECALCULATORAPP.submitPageEvent({
            EventType: 'carfinancecalculator:provider:clicked',
            EventInfo: {
                'ProviderType': providerType,
                'IsDropdown': isDropdown
            }
        });
    };

    CONFUSEDCARFINANCECALCULATORAPP.submitPageEvent = function (eventInfo) {
        CONFUSEDCMS.services.MiService().pageEvent(eventInfo);
    };

}());